const ENVELOPE_KEYS = [
  'content',
  'payload',
  'extra',
  'page',
  'data',
  'body',
  'meta',
  'trace',
  'diagnostics',
  'diagnostic',
  'error',
  'errors',
  'detail',
  'details',
  'cause'
]

const UNAVAILABLE_TOKENS = [
  'stub',
  'falseproof',
  'false_proof',
  'false-proof',
  'false proof',
  'failclosed',
  'fail_closed',
  'fail-closed',
  'fail closed',
  'unconfirmed',
  'unconfirmedsuccess',
  'unconfirmed_success',
  'unconfirmed-success',
  'unconfirmed success',
  'mock',
  'mock_fallback',
  'mock-fallback',
  'mock fallback',
  'fallback',
  'fallback_used',
  'fallback-used',
  'fallback used',
  'dataunavailable',
  'data_unavailable',
  'data-unavailable',
  'data unavailable',
  'unavailable',
  'disabled',
  'read_only',
  'readonly',
  'read only',
  'read-only',
  'read_only_action',
  'read-only-action',
  'read only action',
  'unimplemented',
  'not_implemented',
  'not implemented',
  'not_supported',
  'not-supported',
  'not supported',
  'unsupported',
  'write_blocked',
  'writeblocked',
  'write blocked',
  'write-blocked',
  'backend_blocked',
  'backendblocked',
  'backend blocked',
  'backend-blocked',
  'payment_backend_blocked',
  'paymentbackendblocked',
  'payment backend blocked',
  'payment-backend-blocked',
  'action_blocked',
  'actionblocked',
  'action blocked',
  'action-blocked',
  'read_failure',
  'read-failure',
  'read failure',
  'route_unavailable',
  'routeunavailable',
  'route-unavailable',
  'route unavailable',
  'read_unavailable',
  'readunavailable',
  'read-unavailable',
  'read unavailable',
  'technical_error',
  'technical-error',
  'technical error',
  'technical_marker',
  'technicalmarker',
  'technical-marker',
  'technical marker',
  'backend_failure',
  'backendfailure',
  'backend-failure',
  'backend failure',
  'technical_exception',
  'technical-exception',
  'technical exception',
  '技术错误',
  '技术异常',
  'read_blocked',
  'readblocked',
  'read-blocked',
  'read blocked',
  'proxy_read_failure',
  'proxy-read-failure',
  'proxy read failure',
  'blocked',
  'not_connected',
  'not-connected',
  'not connected',
  'need_login',
  'fail',
  'failed',
  'failure',
  'error',
  'rejected'
]

function safeString(value) {
  if (value === undefined || value === null) return ''
  return String(value).trim()
}

function unavailableToken(value) {
  return safeString(value).toLowerCase()
}

function isUnavailableToken(value) {
  const token = unavailableToken(value)
  return Boolean(token) && (
    UNAVAILABLE_TOKENS.includes(token) ||
    token.includes('mock') ||
    token.includes('falseproof') ||
    token.includes('false_proof') ||
    token.includes('false-proof') ||
    token.includes('false proof') ||
    token.includes('failclosed') ||
    token.includes('fail_closed') ||
    token.includes('fail-closed') ||
    token.includes('fail closed') ||
    token.includes('unconfirmed') ||
    token.includes('fallback') ||
    token.includes('dataunavailable') ||
    token.includes('data_unavailable') ||
    token.includes('data-unavailable') ||
    token.includes('data unavailable') ||
    token.includes('read_only') ||
    token.includes('read only') ||
    token.includes('read-only') ||
    token.includes('unimplemented') ||
    token.includes('not_implemented') ||
    token.includes('not implemented') ||
    token.includes('not_supported') ||
    token.includes('not-supported') ||
    token.includes('not supported') ||
    token.includes('unsupported') ||
    token.includes('write_blocked') ||
    token.includes('writeblocked') ||
    token.includes('write blocked') ||
    token.includes('write-blocked') ||
    token.includes('backend_blocked') ||
    token.includes('backendblocked') ||
    token.includes('backend blocked') ||
    token.includes('backend-blocked') ||
    token.includes('payment_backend_blocked') ||
    token.includes('paymentbackendblocked') ||
    token.includes('payment backend blocked') ||
    token.includes('payment-backend-blocked') ||
    token.includes('action_blocked') ||
    token.includes('actionblocked') ||
    token.includes('action blocked') ||
    token.includes('action-blocked') ||
    token.includes('read_failure') ||
    token.includes('read-failure') ||
    token.includes('read failure') ||
    token.includes('route_unavailable') ||
    token.includes('routeunavailable') ||
    token.includes('route-unavailable') ||
    token.includes('route unavailable') ||
    token.includes('read_unavailable') ||
    token.includes('readunavailable') ||
    token.includes('read-unavailable') ||
    token.includes('read unavailable') ||
    token.includes('technical_error') ||
    token.includes('technical-error') ||
    token.includes('technical error') ||
    token.includes('technical_marker') ||
    token.includes('technicalmarker') ||
    token.includes('technical-marker') ||
    token.includes('technical marker') ||
    token.includes('backend_failure') ||
    token.includes('backendfailure') ||
    token.includes('backend-failure') ||
    token.includes('backend failure') ||
    token.includes('technical_exception') ||
    token.includes('technical-exception') ||
    token.includes('technical exception') ||
    token.includes('技术错误') ||
    token.includes('技术异常') ||
    token.includes('read_blocked') ||
    token.includes('readblocked') ||
    token.includes('read-blocked') ||
    token.includes('read blocked') ||
    token.includes('proxy_read_failure') ||
    token.includes('proxy-read-failure') ||
    token.includes('proxy read failure') ||
    token.includes('not_connected') ||
    token.includes('not-connected') ||
    token.includes('not connected') ||
    token.includes('need_login')
  )
}

function isActiveGuardFlag(value) {
  if (value === true || value === 1) return true
  const token = unavailableToken(value)
  return ['true', '1', 'yes', 'on'].includes(token) || isUnavailableToken(value)
}

function hasUnavailableMessage(value) {
  const token = unavailableToken(value)
  return Boolean(token) && (
    isUnavailableToken(token) ||
    token.includes('\u672a\u63a5\u5165') ||
    token.includes('\u53ea\u8bfb') ||
    token.includes('\u963b\u6b62\u5047\u6210\u529f') ||
    token.includes('\u963b\u6b62\u5047\u53d1\u5956') ||
    token.includes('not connected') ||
    token.includes('not_connected') ||
    token.includes('not-connected') ||
    token.includes('not implemented') ||
    token.includes('read only') ||
    token.includes('read-only') ||
    token.includes('route unavailable') ||
    token.includes('route-unavailable') ||
    token.includes('route_unavailable') ||
    token.includes('read unavailable') ||
    token.includes('read-unavailable') ||
    token.includes('read_unavailable') ||
    token.includes('technical error') ||
    token.includes('technical-error') ||
    token.includes('technical_error') ||
    token.includes('technical marker') ||
    token.includes('technical-marker') ||
    token.includes('technical_marker') ||
    token.includes('technicalmarker') ||
    token.includes('backend failure') ||
    token.includes('backend-failure') ||
    token.includes('backend_failure') ||
    token.includes('backendfailure') ||
    token.includes('technical exception') ||
    token.includes('technical-exception') ||
    token.includes('technical_exception') ||
    token.includes('技术错误') ||
    token.includes('技术异常') ||
    token.includes('read blocked') ||
    token.includes('read-blocked') ||
    token.includes('read_blocked') ||
    token.includes('write blocked') ||
    token.includes('write-blocked') ||
    token.includes('write_blocked') ||
    token.includes('backend blocked') ||
    token.includes('backend-blocked') ||
    token.includes('backend_blocked') ||
    token.includes('payment backend blocked') ||
    token.includes('payment-backend-blocked') ||
    token.includes('payment_backend_blocked') ||
    token.includes('failclosed') ||
    token.includes('fail_closed') ||
    token.includes('fail-closed') ||
    token.includes('fail closed')
  )
}

function isFalseGuardFlag(value) {
  if (value === false || value === 0) return true
  const token = unavailableToken(value)
  return ['false', '0', 'no', 'off'].includes(token)
}

export function hasShareUnavailableMarker(value, depth = 0, seen = new Set()) {
  if (!value || typeof value !== 'object' || depth > 8 || seen.has(value)) return false
  seen.add(value)
  if (Array.isArray(value)) {
    return value.some(item => hasShareUnavailableMarker(item, depth + 1, seen))
  }

  const flags = [
    value.readOnly,
    value.readonly,
    value.read_only,
    value.readOnlyQuery,
    value.read_only_query,
    value.readOnlyMode,
    value.read_only_mode,
    value.readOnlyAction,
    value.read_only_action,
    value.routeUnavailable,
    value.route_unavailable,
    value.readUnavailable,
    value.read_unavailable,
    value.technicalError,
    value.technical_error,
    value.technicalException,
    value.technical_exception,
    value.technicalMarker,
    value.technical_marker,
    value.backendFailure,
    value.backend_failure,
    value.readBlocked,
    value.read_blocked,
    value.falseProof,
    value.false_proof,
    value.failClosed,
    value.fail_closed,
    value.unconfirmed,
    value.unconfirmedSuccess,
    value.unconfirmed_success,
    value.mock,
    value.mockMode,
    value.mock_mode,
    value.mockFallback,
    value.mock_fallback,
    value.fallback,
    value.fallbackUsed,
    value.fallback_used,
    value.dataUnavailable,
    value.data_unavailable,
    value.stub,
    value.unavailable,
    value.unimplemented,
    value.notImplemented,
    value.not_implemented,
    value.unsupported,
    value.notSupported,
    value.not_supported,
    value.writeBlocked,
    value.write_blocked,
    value.backendBlocked,
    value.backend_blocked,
    value.paymentBackendBlocked,
    value.payment_backend_blocked,
    value.actionBlocked,
    value.action_blocked,
    value.readFailure,
    value.read_failure,
    value.proxyReadFailure,
    value.proxy_read_failure,
    value.blocked,
    value.block,
    value.failed
  ]
  if (flags.some(isActiveGuardFlag)) return true

  const falseProofFlags = [
    value.writeProof,
    value.write_proof
  ]
  if (falseProofFlags.some(isFalseGuardFlag)) return true

  const markerValues = [
    value.status,
    value.state,
    value.result,
    value.marker,
    value.type,
    value.code,
    value.errorCode,
    value.fallbackSource,
    value.fallback_source
  ]
  if (markerValues.some(isUnavailableToken)) return true
  if ([value.msg, value.message, value.reason, value.desc, value.description].some(hasUnavailableMessage)) return true
  if (value.success === false || unavailableToken(value.success) === 'false') return true

  return ENVELOPE_KEYS.some(key => hasShareUnavailableMarker(value[key], depth + 1, seen))
}

export function shareFailMessage(response, fallback = 'Request failed') {
  const unavailableMessage = shareUnavailableMessage(response)
  const message = firstMessage(response)
  if (unavailableMessage) {
    if (message && hasUnavailableMessage(message)) return `${unavailableMessage}：${message}`
    if (message && (isGenericFailureMessage(message, fallback) || isTechnicalFailureMessage(message))) return unavailableMessage
    if (message && !hasUnavailableMessage(message)) return message
    return unavailableMessage
  }
  if (message && !isTechnicalFailureMessage(message)) return message
  if (hasShareUnavailableMarker(response)) return '分享数据不可用'
  return fallback || 'Request failed'
}

function shareUnavailableMessage(response) {
  if (hasShareBlockedMarker(response)) return 'This feature is temporarily unavailable. Please try again later.'
  if (hasShareReadOnlyMarker(response)) return 'This feature is temporarily unavailable. Please try again later.'
  if (hasShareNeedLoginMarker(response)) return '分享数据不可用，请先登录'
  if (hasShareUnavailableMarker(response)) return '分享数据不可用'
  return ''
}

function isGenericFailureMessage(message, fallback = '') {
  const token = unavailableToken(message)
  const fallbackToken = unavailableToken(fallback)
  return Boolean(token) && (
    token === fallbackToken ||
    token === 'request failed' ||
    token === 'network error' ||
    token === 'error' ||
    token === 'failed' ||
    token === 'failure'
  )
}

function isTechnicalFailureMessage(value) {
  const message = safeString(value)
  const token = unavailableToken(message)
  if (!token) return false
  return token === 'request failed' ||
    token === 'network error' ||
    token === 'error' ||
    token === 'technical_error' ||
    token === 'technical_exception' ||
    token === 'technical_marker' ||
    token === 'backend_failure' ||
    /^request failed(?:\s|$)/i.test(message) ||
    /(?:technical[_\s-]*(?:error|exception|marker)|backend[_\s-]*failure)/i.test(message) ||
    /技术错误|技术异常/.test(message) ||
    /axios(?:error)?/i.test(message) ||
    /\b(?:econn[a-z_]*|enotfound|etimedout|eai_again|socket hang up)\b/i.test(message) ||
    /\b(?:typeerror|referenceerror|syntaxerror|rangeerror):/i.test(message) ||
    /\bat\s+[\w.$<>]+(?:\s|\()/i.test(message) ||
    /\b(?:java\.|sql(?:exception)?|select\s+.+\s+from|insert\s+into|update\s+.+\s+set|delete\s+from)\b/i.test(message)
}

function hasShareReadOnlyMarker(value, depth = 0, seen = new Set()) {
  return hasShareMarker(
    value,
    (key, item) => [
      'readonly',
      'read_only',
      'readonlyquery',
      'read_only_query',
      'readonlymode',
      'read_only_mode',
      'readonlyaction',
      'read_only_action'
    ].includes(key) && isActiveGuardFlag(item),
    item => {
      const token = unavailableToken(item)
      return token.includes('read_only') ||
        token.includes('read only') ||
        token.includes('read-only') ||
        token.includes('readonly')
    },
    depth,
    seen
  )
}

function hasShareBlockedMarker(value, depth = 0, seen = new Set()) {
  return hasShareMarker(
    value,
    (key, item) => [
      'blocked',
      'block',
      'writeblocked',
      'write_blocked',
      'backendblocked',
      'backend_blocked',
      'paymentbackendblocked',
      'payment_backend_blocked',
      'actionblocked',
      'action_blocked',
      'readblocked',
      'read_blocked',
      'falseproof',
      'false_proof',
      'failclosed',
      'fail_closed',
      'unconfirmed',
      'unconfirmedsuccess',
      'unconfirmed_success'
    ].includes(key) && isActiveGuardFlag(item),
    item => {
      const token = unavailableToken(item)
      return token.includes('write_blocked') ||
        token.includes('writeblocked') ||
        token.includes('write blocked') ||
        token.includes('write-blocked') ||
        token.includes('backend_blocked') ||
        token.includes('backendblocked') ||
        token.includes('backend blocked') ||
        token.includes('backend-blocked') ||
        token.includes('payment_backend_blocked') ||
        token.includes('paymentbackendblocked') ||
        token.includes('payment backend blocked') ||
        token.includes('payment-backend-blocked') ||
        token.includes('action_blocked') ||
        token.includes('actionblocked') ||
        token.includes('action blocked') ||
        token.includes('action-blocked') ||
        token.includes('read_blocked') ||
        token.includes('readblocked') ||
        token.includes('read-blocked') ||
        token.includes('read blocked') ||
        token.includes('falseproof') ||
        token.includes('false_proof') ||
        token.includes('false-proof') ||
        token.includes('false proof') ||
        token.includes('failclosed') ||
        token.includes('fail_closed') ||
        token.includes('fail-closed') ||
        token.includes('fail closed') ||
        token.includes('unconfirmed') ||
        token === 'blocked'
    },
    depth,
    seen
  )
}

function hasShareNeedLoginMarker(value, depth = 0, seen = new Set()) {
  return hasShareMarker(
    value,
    (key, item) => ['needlogin', 'need_login'].includes(key) && isActiveGuardFlag(item),
    item => {
      const token = unavailableToken(item)
      return token === 'need_login' ||
        token === 'needlogin' ||
        token === 'login_required' ||
        token === 'unauthorized' ||
        token === 'token_expired' ||
        token === 'expired_token' ||
        token === 'login_expired' ||
        token === 'session_expired'
    },
    depth,
    seen
  )
}

function hasShareMarker(value, keyMatcher, valueMatcher, depth = 0, seen = new Set()) {
  if (!value || typeof value !== 'object' || depth > 8 || seen.has(value)) return false
  seen.add(value)
  const entries = Array.isArray(value)
    ? value.map((item, index) => [String(index), item])
    : Object.entries(value)
  for (const [key, item] of entries) {
    const normalizedKey = unavailableToken(key).replace(/-/g, '_')
    if (keyMatcher(normalizedKey, item) || valueMatcher(item)) return true
    if (item && typeof item === 'object' && hasShareMarker(item, keyMatcher, valueMatcher, depth + 1, seen)) return true
  }
  if (!Array.isArray(value)) {
    for (const key of ENVELOPE_KEYS) {
      const item = value[key]
      if (item && typeof item === 'object' && hasShareMarker(item, keyMatcher, valueMatcher, depth + 1, seen)) return true
    }
  }
  return false
}

function firstMessage(value, depth = 0, seen = new Set()) {
  if (!value || typeof value !== 'object' || depth > 8 || seen.has(value)) return ''
  seen.add(value)
  if (!Array.isArray(value)) {
    const message = safeString(value.msg || value.message || value.errorMsg || value.errorMessage || value.reason)
    if (message) return message
  }
  const nested = Array.isArray(value) ? value : ENVELOPE_KEYS.map(key => value[key])
  for (const item of nested) {
    const message = firstMessage(item, depth + 1, seen)
    if (message) return message
  }
  return ''
}

export function safeInviteCode(value) {
  const text = safeString(value)
  if (!text || isUnavailableToken(text)) return ''
  if (['#', 'about:blank', 'javascript:void(0)', 'null', 'undefined', 'none'].includes(unavailableToken(text))) return ''
  return text
}

export function safeInviteUrl(origin, country, inviteCode) {
  const code = safeInviteCode(inviteCode)
  const base = safeString(origin).replace(/\/+$/g, '')
  if (!code || !/^https?:\/\//i.test(base)) return ''
  const prefix = safeString(country).replace(/^\/+|\/+$/g, '').replace(/[^A-Za-z0-9_-]/g, '')
  return `${base}${prefix ? `/${prefix}` : ''}/home?id=${encodeURIComponent(code)}`
}

function getBrowserDocument() {
  try {
    if (typeof document !== 'undefined' && document) return document
  } catch (e) {
    return null
  }
  return null
}

export function copyTextToClipboard(value) {
  const text = safeString(value)
  const doc = getBrowserDocument()
  let body = null
  try {
    body = doc && doc.body
    if (
      !text ||
      !body ||
      typeof doc.createElement !== 'function' ||
      typeof body.appendChild !== 'function'
    ) return false
  } catch (e) {
    return false
  }
  const textarea = doc.createElement('textarea')
  if (!textarea || typeof textarea.select !== 'function') return false
  textarea.value = text
  textarea.setAttribute && textarea.setAttribute('readonly', 'readonly')
  if (textarea.style) {
    textarea.style.position = 'fixed'
    textarea.style.opacity = '0'
    textarea.style.pointerEvents = 'none'
  }
  let appended = false
  try {
    body.appendChild(textarea)
    appended = true
    textarea.select()
    const copied = typeof doc.execCommand === 'function' && doc.execCommand('copy')
    return copied !== false
  } catch (e) {
    return false
  } finally {
    if (appended) {
      const parentNode = textarea && textarea.parentNode ? textarea.parentNode : body
      if (parentNode && typeof parentNode.removeChild === 'function') {
        try {
          parentNode.removeChild(textarea)
        } catch (e) {
          // Ignore cleanup errors after a failed copy attempt.
        }
      }
    }
  }
}
